<template>
  <div class="pa-5">
    <v-card shaped class="elevation-10">
      <v-card-title>{{ `${form_title}บทความ` }}</v-card-title>      
      <v-card-text class="pt-0">
				<v-select v-model="form.group_id" outlined dense :items="km_groups" item-text="group_th" item-value="id" label="ประเภทบทความ"></v-select>
				<v-text-field dense outlined v-model="form.topic" label="ชื่อบทความ"></v-text-field>				
        <editor v-model="form.content" :init="editor_config"/>
        <v-file-input v-model="form.files" class="mt-5" dense outlined multiple label="แนบไฟล์" v-if="form_type === 'NEW'"></v-file-input>
      </v-card-text>
      <v-card-actions class="d-flex flex-row justify-center">
        <v-btn color="success" @click="submit">บันทึก</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
import tinymceConfig from './tinymce_config.js';

export default {
	components: {
    editor: Editor
  },
  data: () => ({
		editor_config: tinymceConfig,
    form: {
      group_id: '',
      topic: '',
			content: '',
			files: null
    }
  }),
  computed: {
    form_type() { return this.$route.meta.form_type },
    form_title() { return this.$route.meta.form_title },
    km_groups() { return this.$store.state.km.km_groups },
  },
  mounted() {
    if(this.form_type === 'EDIT') {
      this.$store.dispatch('km/edit', this.$route.params.id)
        .then(resp => {
          this.form = {
            id: resp.id,
            group_id: resp.group_id,
						topic: resp.topic,
						content: resp.content
          }
        });
    }
  },
  methods: {
    submit() {
      this.$store.dispatch(`${this.form_type === 'CREATE' ? 'km/store' : 'km/update'}`, this.createFormData(this.form)).then(() => {
        this.$router.push({ name: 'KMList' });
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'success',
          message: 'บันทึกข้อมูลสำเร็จ'
        });
      }).catch(() => {
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'error',
          message: 'เกิดข้อผิดพลาดบางอย่าง'
        });
      });
    },
		createFormData(form) {
      let formData = new FormData;
      
      if(form.id) {
        formData.append('id', form.id);
      }

      formData.append('group_id', form.group_id);
      formData.append('topic', form.topic);
      formData.append('content', form.content);
      
      if(form.files) {
        form.files.forEach(item => {
          formData.append('files[]', item);
        });
      }
      
			return formData;
    }
  }
}
</script>

<style lang="scss">
  .cover-zone {
    border: 2px dashed;
    cursor: pointer;
  }
  .img-fluid {
    width: 100%;
  }
</style>